/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const hubSpotCompanyDataSchema = z.object({
	id: z.string(),
	name: z.string().nullable(),
	domain: z.string().nullable(),
	city: z.string().nullable(),
	country: z.string().nullable(),
})

export type HubSpotCompanyDataSchema = z.infer<typeof hubSpotCompanyDataSchema>
